import { ROLES } from 'globalconfig/constants/keys';

const routeConfigs = [
  {
    url: '/user/profile',
    component: 'Profile',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER', ROLES.SERVICE_MANAGER],
    module: 'profile',
    title: 'Edit Profile',
    dependency: ['dvirOnly']
  },
  {
    url: '/welcome',
    component: 'Welcome',
    title: 'Welcome',
    roles: ['OWNER'],
    layout: 'welcome',
    module: 'welcome',
    dependency: ['dvirOnly']
  },
  {
    url: '/logs/archive_list',
    component: 'ArchiveLogs',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER'],
    subscriptions: '',
    module: 'archiveLogsList',
    title: 'Logs'
  },
  {
    url: '/downloadCenter/list',
    component: 'DownloadCenter',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'downloadCenterEnabled',
    title: 'Download Center'
  },
  {
    url: '/scheduling/list',
    component: 'ManageScheduling',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'manageScheduling',
    title: 'Manage Scheduling'
  },
  {
    url: '/accidents/list',
    component: 'Accidents',
    roles: ['FLMANAGER', 'ADMIN', 'MECHANIC'],
    module: 'accidentsList',
    title: 'Accidents',
    subscriptions: 'wAccidents'
  },
  {
    url: '/inspections/customdvir',
    component: 'CustomDvir',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'customDvirEnabled',
    title: 'Custom DVIR',
    dependency: ['customDvirEnabled', 'dvirOnly']

  },
  {
    url: '/inspections/customdvir/edit/:id',
    component: 'AddOrEditNewForm',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'addOrEditNewForm',
    title: 'Edit Custom DVIR',
    dependency: ['customDvirEnabled', 'dvirOnly']
  },

  {
    url: '/inspections/customdvir/add',
    component: 'AddOrEditNewForm',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'addOrEditNewForm',
    title: 'Add Custom DVIR',
    dependency: ['customDvirEnabled', 'dvirOnly']
  },
  {
    url: '/inspections/customdvir/addTrailer',
    component: 'AddOrEditNewFormTrailer',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'AddOrEditNewFormTrailer',
    title: 'Add Custom DVIR',
    dependency: ['customDvirEnabled', 'dvirOnly']
  },
  {
    url: '/inspections/customdvir/editTrailer/:id',
    component: 'AddOrEditNewFormTrailer',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'AddOrEditNewFormTrailer',
    title: 'Edit Custom DVIR',
    dependency: ['customDvirEnabled', 'dvirOnly']
  },
  {
    url: '/policy/edit',
    component: 'Policies',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'policyEdit',
    title: 'Policies and Procedures',
    subscriptions: 'wPoliciesAndProcedures'
  },
  {
    url: '/logs/add',
    component: 'AddLogs',
    roles: ['FLMANAGER', 'DRIVER'],
    module: 'logsAdd',
    title: 'Logs'
  },
  {
    url: '/logs/realTimeList',
    component: 'RealTimeLogs',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER'],
    module: 'realTimeLogsList',
    title: 'Logs',
    subscriptions: 'wLogs'
  },
  {
    url: '/dashboard',
    component: 'Dashboard',
    title: 'Dashboard',
    roles: ['FLMANAGER', 'ADMIN'],
    layout: 'plain',
    subscriptions: 'wDashboard',
    module: 'dashboard'
  },
  {
    url: '/vehicle/dtc/:id',
    component: 'ViewDCA',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'viewDCA',
    title: 'Diagnostic Code Alerts',
  },
  {
    url: '/driverStatus/list',
    component: 'DriverStatusViewMore',
    roles: ['FLMANAGER', 'ADMIN'],
    title: 'Driver Status',
    module: 'driverStatusViewMore'
  },
  {
    url: '/violations/list',
    component: 'PotentialViolations',
    roles: ['FLMANAGER', 'ADMIN'],
    title: 'Violations',
    module: 'potentialViolationsViewMore'
  },
  {
    url: '/',
    component: 'InitialLoad',
    title: 'HCSS eLogs',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER', ROLES.SERVICE_MANAGER],
    layout: 'plain',
    module: 'root',
    dependency: ['dvirOnly']
  },
  {
    url: '/logs/logbook/:id',
    component: 'LogBook',
    roles: ['FLMANAGER', 'DRIVER'],
    module: 'logBook',
    title: 'Log Book'
  },
  {
    url: '/logs/history/:id',
    component: 'LogHistory',
    roles: ['FLMANAGER'],
    subscriptions: '',
    module: 'logsHistory',
    title: 'Log History'
  },
  {
    url: '/logs/ud_list',
    component: 'UndefinedDriverList',
    roles: ['FLMANAGER', 'ADMIN'],
    subscriptions: '',
    module: 'logsUdList',
    title: 'Logs'
  },
  {
    url: '/logs/edit/:id',
    component: 'EditDailyLog',
    roles: ['FLMANAGER', 'DRIVER'],
    subscriptions: '',
    module: 'logsEdit',
    title: 'Logs'
  },
  {
    url: '/logs/view/:id',
    component: 'EditDailyLog',
    roles: ['FLMANAGER', 'ADMIN'],
    subscriptions: '',
    module: 'logsView',
    title: 'Logs'
  },
  {
    url: '/logs/list',
    component: 'ManageLogs',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER'],
    subscriptions: '',
    module: 'logsList',
    title: 'Logs'
  },

  {
    url: '/user/list',
    component: 'Users',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    subscriptions: 'wUsersList',
    module: 'userList',
    title: 'Manage Users',
    dependency: ['dvirOnly']
  },
  {
    url: '/violations/list',
    component: 'PotentialViolations',
    roles: ['FLMANAGER', 'ADMIN'],
    subscriptions: '',
    module: 'potentialViolationsViewMore',
    title: 'Violations'
  },
  {
    url: '/company/edit',
    component: 'CompanyData',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    subscriptions: '',
    module: 'companyDataEdit',
    title: 'Company Data',
    dependency: ['dvirOnly']
  },
  {
    url: '/user/add',
    component: 'AddUser',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    subscriptions: '',
    module: 'addUser',
    title: 'Add User',
    dependency: ['dvirOnly']
  },
  {
    url: '/user/edit/:id',
    component: 'EditUser',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    subscriptions: 'wUserDetails',
    module: 'editUser',
    title: 'User details',
    dependency: ['dvirOnly']
  },
  {
    url: '/vehicle/status/list',
    component: 'VehicleStatusList',
    roles: ['FLMANAGER', 'ADMIN'],
    subscriptions: '',
    module: 'vehicleStatusViewMore',
    title: 'Vehicle Status',
    dependency: ['geometrisEnabled', 'dvirOnly']
  },
  {
    url: '/vehicle/list',
    component: 'Vehicles',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    subscriptions: 'wVehiclesList',
    module: 'vehicleList',
    title: 'Manage Vehicles',
    dependency: ['dvirOnly']
  },
  {
    url: '/vehicle/add',
    component: 'AddVehicle',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    subscriptions: '',
    module: 'addVehicle',
    title: 'Add vehicle',
    dependency: ['dvirOnly']

  },
  {
    url: '/vehicle/edit/:id',
    component: 'EditVehicle',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER ],
    subscriptions: 'wVehicleDetails',
    module: 'editVehicle',
    title: 'Edit vehicle',
    dependency: ['dvirOnly']

  },
  {
    url: '/trailer/add',
    component: 'AddTrailer',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    module: 'addTrailer',
    title: 'Add Trailer',
    dependency: ['dvirOnly']

  },
  {
    url: '/trailer/edit/:id',
    component: 'EditTrailer',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    module: 'editTrailer',
    title: 'Edit Trailer',
    dependency: ['dvirOnly']

  },
  {
    url: '/driverStatus/history',
    component: 'DriverStatusHistory',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'driverStatusHistory',
    title: 'History of Driver',
    dependency: ['dvirOnly']

  },
  {
    url: '/vehicle/history',
    component: 'Vehicles',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'vehicleHistory',
    title: 'Manage Vehicles',
    dependency: ['dvirOnly']

  },
  {
    url: '/alerts/requests',
    component: 'DeveloperRequests',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'alertsRequests',
    title: 'Developer Permission Requests',
  },
  {
    url: '/department/list/:id',
    component: 'Department',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'departmentsList',
    title: 'Add Department',
    dependency: ['dvirOnly']

  },
  {
    url: '/report/mileage',
    component: 'IFTAMileage',
    roles: ['FLMANAGER', 'ADMIN'],
    subscriptions: 'wIFTAReport',
    module: 'reportMileage',
    title: 'IFTA Mileage'
  },
  {
    url: '/report/ifta/list',
    component: 'IFTAList',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'iftaList',
    title: 'IFTA Mileage',
    dependency: ['taxableMilesViewEnabled']
  },
  {
    url: '/report/state/add',
    component: 'AddState',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'addState',
    title: 'Add State',
    dependency: ['taxableMilesViewEnabled']
  },
  {
    url: '/report/state/edit/:id',
    component: 'EditState',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'editState',
    title: 'Edit State',
    dependency: ['taxableMilesViewEnabled']
  },
  {
    url: '/report',
    component: 'Report',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'reportsEnabled',
    title: 'Reports',
    dependency: ['dvirOnly']

  },
  {
    url: '/logs/fmcsaLogs',
    component: 'DotAudit',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'fmcsaLogs',
    title: 'DOT Audit'
  },

  {
    url: '/inspections/list',
    component: 'Inspections',
    roles: ['FLMANAGER', 'ADMIN'],
    subscriptions: 'wInspections',
    module: 'inspections',
    title: 'Inspections',
    dependency: ['dvirOnly']
  },
  {
    url: '/inspections/pending-mechanic',
    component: 'PendingMechanicInspections',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    subscriptions: 'wInspections',
    module: 'pendingMechanicInspections',
    title: 'Inspections',
    dependency: ['dvirOnly', 'dvirSpecific']
  },
  {
    url: '/inspections/pending-driver',
    component: 'PendingDriverInspections',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    subscriptions: 'wInspections',
    module: 'pendingDriverInspections',
    title: 'Inspections',
    dependency: ['dvirOnly', 'dvirSpecific']
  },
  {
    url: '/inspections/completed',
    component: 'CompletedInspections',
    roles: ['FLMANAGER', 'ADMIN', ROLES.SERVICE_MANAGER],
    subscriptions: 'wInspections',
    module: 'completedInspections',
    title: 'Inspections',
    dependency: ['dvirOnly', 'dvirSpecific']
  },
  {
    url: '/inspections/no-defect',
    component: 'NoDefectInspections',
    roles: ['FLMANAGER', 'ADMIN'],
    subscriptions: 'wInspections',
    module: 'noDefectInspections',
    title: 'Inspections',
    dependency: ['dvirOnly', 'dvirSpecific']
  },
  {
    url: '/inspections/unassigned',
    component: 'UnassignedInspections',
    roles: [ROLES.SERVICE_MANAGER],
    subscriptions: 'wInspections',
    module: 'unassignedInspections',
    title: 'Inspections',
    dependency: ['dvirOnly', 'dvirSpecific']
  },
  {
    url: '/usdot/management',
    component: 'UsDotNoManagement',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'usDotManagementenabled',
    title: 'USDOT No. Management Page'
  },
  {
    url: '/inspections/advanceConfig',
    component: 'AdvancedConfig',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'advancedDvirEnabled',
    title: 'Advance Config',
    dependency: ['dvirOnly']

  },

  {
    url: '/logs/edit/0/:id',
    component: 'EditDailyLog',
    roles: ['FLMANAGER'],
    module: 'editLog',
    title: 'Logs'
  },
  {
    url: '/logs/logbookFilter/:id',
    component: 'LogBook',
    roles: ['FLMANAGER'],
    module: 'logbookFilterId',
    title: 'Log Book'
  },
  {
    url: '/logs/logbookFilter/:id/:date',
    component: 'LogBook',
    roles: ['FLMANAGER'],
    module: 'logbookFilterIdDate',
    title: 'Log Book'
  },
  {
    url: '/fuel/list',
    component: 'FuelConsumptionReport',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'fuelConsumptionReport',
    title: 'Fuel Track List',
    subscriptions: 'wFuelConsumptionReport'
  },
  {
    url: '/fuel/history/:id',
    component: 'RefillsHistory',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'refillsHistory',
    title: 'History of Refills'
  },
  {
    url: '/dashboard/geometris/hardDecceleration/detail',
    component: 'HardDeceleration',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'hardDeceleration',
    title: 'Vehicle Status',
    dependency: ['geometrisEnabled']
  },
  {
    url: '/dashboard/geometris/hardAcceleration/detail',
    component: 'HardAcceleration',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'hardAcceleration',
    title: 'Vehicle Status',
    dependency: ['geometrisEnabled']
  },
  {
    url: '/dashboard/geometris/speeding/detail',
    component: 'Speeding',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'speeding',
    title: 'Vehicle Status',
    dependency: ['geometrisEnabled']
  },
  {
    url: '/dashboard/geometris/driveHrsExceeding/detail',
    component: 'DriveHrsExceeding',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'driveHrsExceeding',
    title: 'Vehicle Status',
    dependency: ['geometrisEnabled']
  },
  {
    url: '/dashboard/geometris/fuelEconomy/detail',
    component: 'FuelEconomy',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'fuelEconomy',
    title: 'Vehicle Status',
    dependency: ['geometrisEnabled']
  },
  {
    url: '/dashboard/geometris/seatBeltWarning/detail',
    component: 'SeatBeltWarning',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'seatBeltWarning',
    title: 'Vehicle Status',
    dependency: ['geometrisEnabled']
  },
  {
    url: '/dashboard/geometris/hardTurn/detail',
    component: 'HardTurn',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'hardTurn',
    title: 'Vehicle Status',
    dependency: ['geometrisEnabled']
  },
  {
    url: '/inspections/edit/:id',
    component: 'EditWorkOrders',
    roles: ['FLMANAGER', 'MECHANIC', ROLES.SERVICE_MANAGER],
    module: 'editWorkOrder',
    title: 'Inspection Details',
    dependency: ['dvirOnly', 'dvirSpecific']
  },
  {
    url: '/workorders/list',
    component: 'WorkOrders',
    roles: ['FLMANAGER', 'ADMIN', 'MECHANIC'],
    subscriptions: 'wReportAndMaintenance',
    module: 'workOrders',
    title: 'Work Orders'
  },
  {
    url: '/workorders/add',
    component: 'AddWorkOrders',
    roles: ['FLMANAGER', 'ADMIN', 'MECHANIC'],
    module: 'addWorkOrder',
    title: 'Work Order Details'
  },
  {
    url: '/workorders/edit/:id',
    component: 'EditWorkOrders',
    roles: ['FLMANAGER', 'MECHANIC'],
    module: 'editWorkOrder',
    title: 'Work Order Details'
  },
  {
    url: '/parts/list',
    component: 'Parts',
    roles: ['FLMANAGER', 'MECHANIC'],
    module: 'partsInventoryEnabled',
    title: 'Parts'
  },
  {
    url: '/vehicle/notInUse/INSHOP',
    component: 'NotInUseVehicles',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'vehicleNotInUse',
    title: 'Manage Vehicles',
    dependency: ['dvirOnly']
  },
  {
    url: '/vehicle/notInUse/OUTOFSERVICE',
    component: 'OutOfService',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'outOfService',
    title: 'Manage Vehicles',
    dependency: ['dvirOnly']
  },
  {
    url: '/companies/list',
    component: 'Companies',
    roles: [ROLES.SERVICE_MANAGER],
    module: 'companyList',
    title: 'Manage Companies',
    dependency: ['dvirOnly']
  },
  {
    url: '/dailyDocuments/list',
    component: 'DailyDocuments',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'dailyDocuments',
    title: 'DailyDocuments',
    subscriptions: 'wDailyDocuments'
  },
];

export default routeConfigs;
